import { parsePhoneNumberFromString } from "libphonenumber-js";

const regionNamesInEnglish = new Intl.DisplayNames(["en"], { type: "region" });

export function formatMemberPhoneNumber(phoneNumber: string): string {
    const parsed = parsePhoneNumberFromString(phoneNumber);
    if (!parsed) {
        return phoneNumber;
    }

    const international = parsed.formatInternational();
    const country = parsed.country;
    if (!country) {
        return international;
    }

    const countryName = regionNamesInEnglish.of(country);
    if (!countryName) {
        return international;
    }

    return `${countryName} ${international}`;
}
